import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { getDollarValue } from "../../helpers/currency";
import { UNITS } from "../../constants";

import { HubHookFormInput, HubHookFormSelect } from "../../components";

import { StyledItemRow } from "./styles";
import ItemDescriptionField from "./ItemDescriptionField";
import ItemsContextMenu from "./ItemsContextMenu";

const ItemsTableRow = ({
  idx,
  isMold,
  hideQuantity,
  onAppend = () => {},
  onInsert = () => {},
  onRemove = () => {},
}) => {
  const prefix = `items.${idx}`;

  const { watch, setValue } = useFormContext();

  const notes = watch(`${prefix}.notes`);
  const showNotes = watch(`${prefix}.showNotes`) || !!notes;
  const price = watch(`${prefix}.price`) || 0;
  const quantity = watch(`${prefix}.quantity`) || 0;
  const total = isNaN(price * quantity) ? 0 : getDollarValue(price * quantity);

  const onNotesBlur = (_, val) =>
    !val && setValue(`${prefix}.showNotes`, false);

  return (
    <>
      <StyledItemRow key={prefix} rowHeight={isMold ? "36px" : "26px"}>
        <HubHookFormInput
          name={`${prefix}.lineItemId`}
          shouldUnregister={false}
          hidden
        />
        <Typography variant="caption">{idx + 1}</Typography>
        <HubHookFormInput
          name={`${prefix}.quantity`}
          placeholder="Qty"
          shouldUnregister={false}
          disableHelperText
          isNumber
          required
        />
        <HubHookFormSelect
          name={`${prefix}.units`}
          options={UNITS}
          shouldUnregister={false}
          disableHelperText
          required
        />
        <ItemDescriptionField hideQuantity={hideQuantity} prefix={prefix} />
        <HubHookFormInput
          name={`${prefix}.price`}
          placeholder="10.00"
          shouldUnregister={false}
          disableHelperText
          isCurrency
          required
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="caption" className="ItemCell-root">
            {total}
          </Typography>
          <ItemsContextMenu
            idx={idx}
            prefix={prefix}
            onAppend={onAppend}
            onInsert={onInsert}
            onRemove={onRemove}
            allowEdit
          />
        </Stack>
      </StyledItemRow>
      {!!showNotes && (
        <StyledItemRow
          className="LineItemDescription"
          sx={{ backgroundColor: "hubColors.mainFocusLightest" }}
        >
          <Typography variant="caption" sx={{ gridColumn: "span 3" }} />
          <Typography variant="caption">
            <HubHookFormInput
              name={`${prefix}.notes`}
              placeholder="Notes..."
              onBlur={onNotesBlur}
              disableHelperText
              sx={{
                backgroundColor: "transparent !important",
                input: { fontWeight: "400 !important" },
              }}
            />
          </Typography>
        </StyledItemRow>
      )}
    </>
  );
};

export default ItemsTableRow;
